import { render, staticRenderFns } from "./IdeasSectionHeading.vue?vue&type=template&id=e350b26c"
import script from "./IdeasSectionHeading.vue?vue&type=script&lang=js"
export * from "./IdeasSectionHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports